// extracted by mini-css-extract-plugin
export default {"logoContainer":"Logo_logoContainer__oPODI","logoLeaf":"Logo_logoLeaf__g3tiU","logoMobileContainer":"Logo_logoMobileContainer__T2A7M","fadeIn":"Logo_fadeIn__xjlV9"};